export default __webpack_public_path__ + "static/media/certificate-badge-english.ad1b6dca.svg";